import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycarrentalsinpune() {



  const cardData =
  {
    keyword: ' Luxury Car Rentals in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Luxury Car Rentals in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited offers premium Luxury Car Rentals in Pune, providing high-end transportation solutions for corporate executives, VIP guests, business events, and special occasions. Our fleet includes top-tier luxury sedans and SUVs, ensuring a superior level of comfort, style, and performance. Whether it is airport transfers, corporate meetings, conferences, or event travel, we deliver a smooth, elegant, and hassle-free experience. With professionally trained chauffeurs, flexible rental plans, and meticulously maintained luxury vehicles, Pune Corporate Cars India Private Limited ensures a premium travel experience for clients seeking luxury car rentals in Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
{
"name": "Premium Car Hire Pune",
"description": "Premium Car Hire Pune provides top-of-the-line vehicles for corporate, business, and personal travel. The service includes luxury sedans, SUVs, and chauffeur-driven cars, ensuring comfort, safety, and punctuality. Clients benefit from well-maintained vehicles, trained drivers, GPS tracking, and tailored services for executive meetings, airport transfers, and VIP travel across Pune."
},
{
"name": "Luxury Chauffeur Cars Pune",
"description": "Luxury Chauffeur Cars Pune offers high-end, professional driver services with a fleet of premium sedans and SUVs. The service emphasizes discretion, reliability, and comfort, making it ideal for business executives, VIP clients, weddings, and special events. Vehicles are meticulously maintained and drivers are trained to provide exceptional service."
},
{
"name": "Mercedes BMW Audi Rental Pune",
"description": "Mercedes BMW Audi Rental Pune provides an exclusive fleet of luxury vehicles for corporate clients, business travelers, and private occasions. The service ensures a premium travel experience with trained chauffeurs, GPS-monitored vehicles, and personalized booking options. Ideal for executive travel, airport transfers, and high-profile events in Pune."
},
{
"name": "Luxury Corporate Cars Pune",
"description": "Luxury Corporate Cars Pune delivers sophisticated vehicles for corporate employee travel, client meetings, and business events. With chauffeur-driven sedans and SUVs, the service guarantees safety, professionalism, and punctuality. Companies can rely on structured routes, GPS tracking, and premium comfort for executive-level commuting."
},
{
"name": "Business Class Car Rental Pune",
"description": "Business Class Car Rental Pune offers high-end sedans and SUVs for corporate travel, VIP clients, and executive commutes. The service focuses on comfort, timely pickups, professional drivers, and well-maintained vehicles, ensuring a seamless, professional experience for business travelers in Pune and surrounding areas."
},
{
"name": "Luxury Wedding Car Pune",
"description": "Luxury Wedding Car Pune specializes in providing premium vehicles such as limousines, Mercedes, BMW, and Audi for weddings and special occasions. The service includes professionally trained chauffeurs, elegant interiors, and timely coordination to ensure a stylish, memorable, and comfortable transportation experience for wedding parties and guests."
},
{
"name": "Luxury Airport Transfer Pune",
"description": "Luxury Airport Transfer Pune delivers high-end, chauffeur-driven vehicles for seamless airport pickups and drop-offs. The service ensures timely arrivals, luggage assistance, and comfortable travel in premium sedans and SUVs. Ideal for corporate executives, VIP clients, and leisure travelers seeking a stress-free airport commute."
},
{
"name": "Executive Sedan Rental Pune",
"description": "Executive Sedan Rental Pune provides luxury sedans for business executives, office staff, and VIP clients. The service ensures safe, punctual, and comfortable transportation for corporate meetings, airport transfers, and intercity travel. Vehicles are GPS-enabled, well-maintained, and paired with professional chauffeurs."
},
{
"name": "Luxury SUV Rental Pune",
"description": "Luxury SUV Rental Pune offers spacious, powerful, and comfortable SUVs for corporate teams, VIP clients, and family travel. The service provides professional drivers, GPS tracking, and well-maintained vehicles to ensure safe, reliable, and premium commuting or long-distance travel in Pune."
},
{
"name": "Limousine Rental Pune",
"description": "Limousine Rental Pune delivers high-end limousine services for weddings, corporate events, VIP travel, and luxury occasions. The service includes professional chauffeurs, elegant interiors, and full-service arrangements to provide clients with a first-class, stylish, and unforgettable travel experience."
},
{
"name": "Luxury Self Drive Pune",
"description": "Luxury Self Drive Pune offers premium vehicles for customers who prefer to drive themselves. The fleet includes luxury sedans, SUVs, and sports cars, all well-maintained and insured. The service is ideal for personal travel, leisure trips, and corporate clients seeking a high-end, independent driving experience."
},
{
"name": "VIP Travel Car Hire Pune",
"description": "VIP Travel Car Hire Pune provides elite transportation services for high-profile clients, executives, and VIP guests. The service features luxury sedans, SUVs, and limousines with professional chauffeurs, GPS tracking, and meticulous attention to comfort, safety, and punctuality for corporate and personal travel."
},
{
"name": "Premium Fleet Provider Pune",
"description": "Premium Fleet Provider Pune offers businesses access to a fully managed luxury fleet for corporate, executive, and employee transportation. The service includes chauffeur-driven sedans and SUVs, route optimization, GPS monitoring, and maintenance support, ensuring seamless, high-end commuting for companies and VIP clients."
},
{
"name": "Luxury Event Car Pune",
"description": "Luxury Event Car Pune specializes in providing premium vehicles for weddings, corporate events, and private celebrations. With chauffeur-driven luxury sedans, SUVs, and limousines, the service ensures timely, elegant, and safe transportation, making any event more memorable and stylish."
},
{
"name": "Corporate Luxury Mobility Pune",
"description": "Corporate Luxury Mobility Pune delivers high-end transportation solutions for corporate employees, executives, and clients. The service includes premium sedans, SUVs, and chauffeur-driven vehicles with GPS tracking, route planning, and professional drivers, ensuring safe, comfortable, and punctual corporate travel across Pune."
}
],

"tableData": [
["Premium Car Hire Pune", "Luxury Chauffeur Cars Pune"],
["Mercedes BMW Audi Rental Pune", "Luxury Corporate Cars Pune"],
["Business Class Car Rental Pune", "Luxury Wedding Car Pune"],
["Luxury Airport Transfer Pune", "Executive Sedan Rental Pune"],
["Luxury SUV Rental Pune", "Limousine Rental Pune"],
["Luxury Self Drive Pune", "VIP Travel Car Hire Pune"],
["Premium Fleet Provider Pune", "Luxury Event Car Pune"],
["Corporate Luxury Mobility Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Luxury Car Rentals in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers premium luxury car rentals in Pune, providing stylish, comfortable, and high-end vehicles for corporate and personal travel."
  },
  {
    "WhyChooseheading": "Exclusive Fleet of Luxury Vehicles",
    "WhyChoosedescription": "Choose from top-of-the-line sedans, SUVs, and executive cars, all maintained to the highest standards for a luxurious travel experience."
  },
  {
    "WhyChooseheading": "Professional Chauffeur Service",
    "WhyChoosedescription": "Our trained and courteous drivers ensure safe, punctual, and elegant travel for executives, VIP clients, and corporate events."
  },
  {
    "WhyChooseheading": "Customized Rental Packages",
    "WhyChoosedescription": "We provide flexible hourly, daily, and event-based rental plans tailored to meet the needs of corporate clients and individuals seeking luxury travel."
  },
  {
    "WhyChooseheading": "Punctual & Reliable Service",
    "WhyChoosedescription": "Our services prioritize timeliness and dependability, ensuring a seamless luxury travel experience for all occasions."
  },
  {
    "WhyChooseheading": "24/7 Customer Assistance",
    "WhyChoosedescription": "We offer round-the-clock support for bookings, emergencies, and last-minute requests, ensuring a hassle-free luxury rental experience."
  },
  {
    "WhyChooseheading": "Safe & Well-Maintained Vehicles",
    "WhyChoosedescription": "All luxury vehicles are regularly serviced, sanitized, and equipped with modern safety features for a secure and comfortable journey."
  },
  {
    "WhyChooseheading": "Easy Booking & Efficient Coordination",
    "WhyChoosedescription": "Our streamlined booking process and reliable coordination make renting luxury cars simple, convenient, and stress-free."
  }
]





























  }

const faqData = [
  {
    question: 'Do you provide luxury car rentals in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers premium luxury car rentals for corporate clients, VIPs, and special events in Pune.',
  },
  {
    question: 'What types of luxury vehicles are available for rent?',
    answer: 'We offer high-end sedans, SUVs, and luxury cars including Mercedes, BMW, Audi, and Innova Crysta for executive travel.',
  },
  {
    question: 'How can companies or individuals book luxury car rentals in Pune?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate and customer support team.',
  },
  {
    question: 'Do you provide chauffeurs with luxury car rentals?',
    answer: 'Yes, all luxury car rentals come with professional, trained, and uniformed chauffeurs for a comfortable and safe ride.',
  },
  {
    question: 'Can luxury car rentals be booked for corporate events or VIP transfers?',
    answer: 'Absolutely. We provide luxury cars for corporate meetings, airport pickups, client visits, and special events.',
  },
  {
    question: 'Do you offer long-term or monthly rental options for luxury cars?',
    answer: 'Yes, we provide flexible monthly, quarterly, and annual rental packages for corporate and individual clients.',
  },
  {
    question: 'What safety measures are followed for luxury car rentals?',
    answer: 'All luxury vehicles are GPS-enabled, sanitized regularly, and driven by verified and trained chauffeurs.',
  },
  {
    question: 'What payment options are available for luxury car rentals?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide corporate invoicing for business clients.',
  },
  {
    question: 'Can we book multiple luxury cars for corporate events in Pune?',
    answer: 'Yes, we provide multiple luxury vehicles for events, conferences, and VIP transfers based on requirements.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Akshay More',
    feedback: 'Excellent luxury car rental service in Pune. Punctual, professional, and very comfortable cars.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritika Joshi',
    feedback: 'Highly recommend Pune Corporate Cars India Private Limited for luxury rentals. Great service and professional chauffeurs.',
    rating: 5,
  },
];























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Car Rentals in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/luxury-car-rentals-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited offers premium luxury car rentals in Pune, including chauffeur-driven Mercedes, BMW, Audi, executive sedans, SUVs, limousines, and VIP travel cars. Ideal for corporate travel, luxury events, weddings, airport transfers, and high-end business mobility.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5200", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/luxury-car-rentals-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Luxury Car Rentals in Pune | Premium & Executive Cars | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited offers premium luxury car rentals in Pune, including chauffeur-driven Mercedes, BMW, Audi, executive sedans, SUVs, limousines, and VIP travel cars. Ideal for corporate travel, luxury events, weddings, airport transfers, and high-end business mobility."
  />

  <meta
    name="keywords"
    content="Premium Car Hire Pune, Luxury Chauffeur Cars Pune, Mercedes BMW Audi Rental Pune, Luxury Corporate Cars Pune, Business Class Car Rental Pune, Luxury Wedding Car Pune, Luxury Airport Transfer Pune, Executive Sedan Rental Pune, Luxury SUV Rental Pune, Limousine Rental Pune, Luxury Self Drive Pune, VIP Travel Car Hire Pune, Premium Fleet Provider Pune, Luxury Event Car Pune, Corporate Luxury Mobility Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycarrentalsinpune;